// AI
import aiIndex from '@/views/edit/ai/index'

const jspRoutes = Array.from({ length: 28 }, (_, i) => ({
  path: `ai/jsp/index${i + 1}`,
  name: `ai/jsp/Index${i + 1}`,
  component: () => import(`@/views/edit/ai/jsp/index${i + 1}.vue`)
}))
const pyRoutes = Array.from({ length: 30 }, (_, i) => ({
  path: `ai/py/index${i + 1}`,
  name: `ai/py/Index${i + 1}`,
  component: () => import(`@/views/edit/ai/py/index${i + 1}.vue`)
}))
const twcpRoutes = Array.from({ length: 30 }, (_, i) => ({
  path: `ai/twcp/index${i + 1}`,
  name: `ai/twcp/Index${i + 1}`,
  component: () => import(`@/views/edit/ai/twcp/index${i + 1}.vue`)
}))
const yjcpRoutes = Array.from({ length: 30 }, (_, i) => ({
  path: `ai/yjcp/index${i + 1}`,
  name: `ai/yjcp/Index${i + 1}`,
  component: () => import(`@/views/edit/ai/yjcp/index${i + 1}.vue`)
}))

export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'ai/index',
      name: 'aiIndex',
      component: aiIndex
    },
    // AI，开始
    ...jspRoutes,
    ...pyRoutes,
    ...twcpRoutes,
    ...yjcpRoutes
    // AI，结束

  ]
}
